const randomElement = (arr = []) => {
    return arr[Math.floor(Math.random() * arr.length)];
};

const kebab =  (str) => {
    return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};

const toggleFullScreen = () => {
    let doc = window.document;
    let docEl = doc.documentElement;

    let requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
    let cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

    if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
        requestFullScreen.call(docEl);
    }
    else {
        cancelFullScreen.call(doc);
    }
};

const toCurrencyFormat = function (value) {
    value = parseFloat(value);
    let is_negative = value < 0;
    value = Math.abs(value);
    return (is_negative?"-":"") + '$' + value.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
};

const getEnumValues = function(enum_object) {
    return getEnumKeys(enum_object).map(k => enum_object[k]);
};

const getEnumKeys = function(enum_object) {
    return Object.keys(enum_object).filter(k => typeof enum_object[k] === "number");
};

const getIconByFileName = function (filename) {
    filename = filename.toLowerCase();
    if (filename.match(/.xls|.xlsx/)) {
        return 'fa-file-excel';
    } else if (filename.match(/.doc|.docx/)) {
        return 'fa-file-word';
    } else if (filename.match(/.ppt|.pptx/)) {
        return 'fa-file-powerpoint';
    } else if (filename.match(/.zip|.rar/)) {
        return 'fa-file-archive';
    } else if (filename.match(/.pdf/)) {
        return 'fa-file-pdf';
    } else {
        return 'fa-file';
    }
};

const getFileSizeText = function(file_size) {
    let text = "";
    if(file_size >= 1073741824)
    {
        text = Math.round((file_size / 1073741824) * 100) / 100 + ' GB';
    }
    else if(file_size >= 1048576)
    {
        text = Math.round((file_size / 1048576) * 100) / 100 + ' MB';
    }
    else if(file_size >= 1024)
    {
        text = Math.round((file_size / 1024) * 100) / 100 + ' KB';
    }
    else {
        text = file_size + ' byte';
    }
    return text;
};

const getPeriodText = function(start_ts, end_ts) {
    let start_time = getApp.$moment(start_ts * 1000).format('lll');

    let start_date = getApp.$moment(start_ts * 1000).format('LL');
    let end_date = getApp.$moment(end_ts * 1000).format('LL');

    let end_time = (start_date === end_date) ? getApp.$moment(end_ts * 1000).format('LT') : getApp.$moment(end_ts * 1000).format('llll');

    return start_time + ' - ' + end_time;
}

const getPercentageText = function(total, value) {
    return Math.round((value/total)* 100) + '%';
};

let UID = Date.now();
const getUniqueId = function() {
    return (UID++).toString(36) + "x";
};

export default {
    randomElement,
    toggleFullScreen,
    kebab,
    toCurrencyFormat,
    getEnumValues,
    getEnumKeys,
    getIconByFileName,
    getFileSizeText,
    getPercentageText,
    getUniqueId,
    getPeriodText
};